(function () {
  function waitForLenis(cb) {
    if (window.lenisScroll) return cb();
    setTimeout(() => waitForLenis(cb), 50);
  }

  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function isInView(el, offset = 0.85) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh * offset && rect.bottom > 0;
  }

  function initLenisDataAnim(root = document) {
    var items = root.querySelectorAll('[data-lenis-anim]');
    if (!items.length) return;

    items.forEach(el => {
      el.style.willChange = 'transform, opacity';
    });

    function handleInView(force = false) {
      items.forEach(function (el) {
        var type = el.dataset.lenisAnim;
        if (!type || type.indexOf('inview') === -1) return;

        var distance = parseFloat(el.dataset.distance || -60);
        var duration = parseFloat(el.dataset.duration || 0.8);
        var easing = el.dataset.easing || 'ease';

        if (force) {
          delete el.dataset.init;
          delete el.dataset.played;
        }
        if (!el.dataset.init) {
          el.dataset.init = 'true';
          el.style.opacity = 0;

          if (type === 'fade-left-inview') {
            el.style.transform = `translate3d(${distance}px,0,0)`;
          }
          if (type === 'fade-right-inview') {
            el.style.transform = `translate3d(${distance}px,0,0)`;
          }
          if (type === 'fade-up-inview') {
            el.style.transform = `translate3d(0,${distance}px,0)`;
          }

          el.style.transition =
              `transform ${duration}s ${easing}, opacity ${duration}s ${easing}`;
        }
        if (!el.dataset.played && (force || isInView(el))) {
          el.dataset.played = 'true';

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              el.style.opacity = 1;
              el.style.transform = 'translate3d(0,0,0)';
            });
          });
        }
      });
    }

    if (window.lenisScroll) {
      window.lenisScroll.on('scroll', function (e) {
        items.forEach(function (el) {
          var type = el.dataset.lenisAnim;

          if (!type || type.indexOf('inview') !== -1) return;

          var distance = parseFloat(el.dataset.distance || 100);
          var range = parseFloat(el.dataset.range || 800);
          var progress = clamp(e.scroll / range, 0, 1);

          if (type === 'zoom-in') {
            var from = parseFloat(el.dataset.from || 0.85);
            var to = parseFloat(el.dataset.to || 1);
            el.style.transform = `scale(${from + (to - from) * progress})`;
          }

          if (type === 'zoom-out') {
            var from = parseFloat(el.dataset.from || 1.15);
            var to = parseFloat(el.dataset.to || 1);
            el.style.transform = `scale(${from + (to - from) * progress})`;
          }

          if (type === 'zoom') {
            var from = parseFloat(el.dataset.from || 0.9);
            var to = parseFloat(el.dataset.to || 1.1);
            el.style.transform = `scale(${from + (to - from) * progress})`;
          }

          if (type === 'left-right') {
            el.style.transform =
                `translate3d(${(-distance + distance * progress)}px,0,0)`;
          }

          if (type === 'right-left') {
            el.style.transform =
                `translate3d(${(distance - distance * progress)}px,0,0)`;
          }

          if (type === 'bottom-top') {
            el.style.transform =
                `translate3d(0,${(distance - distance * progress)}px,0)`;
          }

          if (type === 'top-bottom') {
            el.style.transform =
                `translate3d(0,${(-distance + distance * progress)}px,0)`;
          }
        });

        handleInView(false);
      });
    }

    handleInView(false);

    if (window.Shopify && Shopify.designMode) {
      setTimeout(() => handleInView(true), 100);
    }
  }

  waitForLenis(() => initLenisDataAnim(document));

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      initLenisDataAnim(e.target);
    });

    document.addEventListener('shopify:section:reorder', () => {
      initLenisDataAnim(document);
    });
  }
})();
(function () {
  function waitForLenis(cb) {
    if (window.lenisScroll) return cb();
    requestAnimationFrame(() => waitForLenis(cb));
  }

  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function initStickyScroll() {
    const items = document.querySelectorAll('.sticky-item');
    if (!items.length) return;

    function update() {
      const center = window.innerHeight / 2;

      items.forEach(item => {
        const content = item.querySelector('.sticky-content');
        if (!content) return;

        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;

        const distance = Math.abs(center - itemCenter);
        const range = window.innerHeight * 0.5;

        let progress = 1 - distance / range;
        progress = clamp(progress, 0, 1);

        content.style.opacity = progress;
        content.style.transform = `
          translateY(-50%)
          scale(${0.9 + progress * 0.1})
        `;
      });
    }

    window.lenisScroll.on('scroll', update);

    requestAnimationFrame(update);
    setTimeout(update, 100);
  }

  waitForLenis(initStickyScroll);
})();